import { render, staticRenderFns } from "./myReview.vue?vue&type=template&id=fb1eabce&scoped=true"
import script from "./myReview.vue?vue&type=script&lang=js"
export * from "./myReview.vue?vue&type=script&lang=js"
import style0 from "./myReview.vue?vue&type=style&index=0&id=fb1eabce&lang=scss&scoped=true"
import style1 from "./myReview.vue?vue&type=style&index=1&id=fb1eabce&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1eabce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb1eabce')) {
      api.createRecord('fb1eabce', component.options)
    } else {
      api.reload('fb1eabce', component.options)
    }
    module.hot.accept("./myReview.vue?vue&type=template&id=fb1eabce&scoped=true", function () {
      api.rerender('fb1eabce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cardSystem/saleToos/projectDelivery/myReview.vue"
export default component.exports